import React from "react";
import { ITestSeriesId } from "../../TestSeries.props";
import EditTestSeries from "./EditTestSeries";

const EditTestSeriesIndex: React.FC<ITestSeriesId> = ({ testSeriesId }) => {
  return <EditTestSeries testSeriesId={testSeriesId} />;
};

export default EditTestSeriesIndex;
